import { useState, useEffect } from "react";
import api from "api/api";
import { useNavigate, Link } from "react-router-dom";

//Material UI Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// import mui icons

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

//Props Validations
import PropTypes from "prop-types";

//import component
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";
import Header from "../components/common/Header";
import CorrelationTab from "components/correlation/CorrelationTab";
import Loader from "../components/common/Loader";
import MainNavigation from "../components/common/MainNavigation";

import { useSelector, useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";

function CustomTabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function Correlation({ headerTitle = "" }) {
    const dispatch = useDispatch();
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    const [productsSecondaryData, setProductsSecondaryData] = useState([]);
    const [kpiOoDataMappingData, setKpiOoDataMappingData] = useState([]);

    const [isKpiOoDataMappingDataLoading, setIsKpiOoDataMappingDataLoading] = useState(false);
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    const btnArr = isOralCare || isSkinCleansing || isHairCare || isSkinCare ? ["overallKpi", "agreementKpi", "justRight", "claims"] : isUnileverFragranceHouse ? ["overallKpi", "agreementKpi", "justRight"] : ["overallKpi", "agreementKpi", "claims"];

    const navigate = useNavigate();

    const [btnDisabled, setBtnDisabled] = useState({
        overallKpi: true,
        agreementKpi: true,
        claims: true,
        correlation: true,
    });

    const compareArrays = (arr1, arr2) => {
        const arrSorted2 = arr2.slice().sort();
        const isArrEqual =
            arr1.length === arr2.length &&
            arr1
                .slice()
                .sort()
                .every((value, index) => {
                    return value === arrSorted2[index];
                });
        return isArrEqual;
    };

    useEffect(() => {
        let _selectedStudies = selectedStudy;
        let disabled = true;
        let _country = _selectedStudies[0]?.country__title;
        let _deodorantFormat = _selectedStudies[0]?.format_data;
        _selectedStudies.forEach((each) => {
            if (each.country__title === _country && compareArrays(each.format_data, _deodorantFormat)) {
                disabled = false;
            } else {
                disabled = true;
            }
        });

        let disableBtn = !_selectedStudies.length > 0;
        let tempObj = {
            overallKpi: disableBtn,
            agreementKpi: disableBtn,
            claims: disableBtn,
            correlation: disabled,
        };
        setBtnDisabled(tempObj);
    }, [selectedStudy]);

    useEffect(() => {
        const ulProArr = [];
        const ulCompProArr = [];
        let array = [];

        selectedStudy.forEach((study) => {
            study.products?.forEach((product) => {
                let datum = {};
                datum.title = product;
                datum.coreDataId = study.id;
                datum.isCompetitorProduct = false;
                ulProArr.push(datum);
                array = [...array, datum];
            });
            study.competitor_products?.forEach((product) => {
                let datum = {};
                datum.title = product;
                datum.coreDataId = study.id;
                datum.isCompetitorProduct = true;
                ulCompProArr.push(datum);
                array = [...array, datum];
            });
        });
        setProductsSecondaryData([...array]);
    }, []);

    useEffect(() => {
        async function fetchKpiOoDataMappingData() {
            try {
                let url = process.env.REACT_APP_SERVER_PATH + `/data-mappings/all/?archive=false&uniq=true&variable_category=${encodeURIComponent("KPI (OO),Secondary Attribute")}`;
                if (productCategoryId) {
                    url += `&product_category=${productCategoryId}`;
                }
                setIsKpiOoDataMappingDataLoading(true);
                await api
                    .get(url)
                    .then((res) => {
                        const data = res.data;
                        setKpiOoDataMappingData(data);
                        setIsKpiOoDataMappingDataLoading(false);
                    })
                    .catch((error) => {
                        handleError("error", error);
                        setIsKpiOoDataMappingDataLoading(false);
                    });
            } catch (error) {
                handleError("error", error);
                setIsKpiOoDataMappingDataLoading(false);
            }
        }

        if (selectedStudy.length === 0) {
            navigate("/studies");
        } else {
            fetchKpiOoDataMappingData();
        }
    }, [productCategoryId]);

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    return (
        <>
            {isKpiOoDataMappingDataLoading && <Loader />}
            <Header
                title={headerTitle}
                isStudySelected={true}
            />
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <FiltersHeaderLabel multipleLabel={true} />
            </div>

            <div
                style={{
                    minHeight: "calc(100vh - 170px)",
                    padding: "20px",
                    margin: "20px",
                    marginTop: "35px",
                }}
                className="full-container m-4 background-color-white  box-shadow--full-container"
            >
                <div
                    className=""
                    style={{
                        width: 150,
                        display: "flex",
                        alignItems: "center",
                        position: "absolute",
                        zIndex: 10,
                    }}
                >
                    <Link to="/studies">
                        <div
                            className="p-2 liner-light-blue-background color-white"
                            style={{
                                borderRadius: "50%",
                                position: "relative",
                                top: -35,
                                left: -35,
                                cursor: "pointer",
                            }}
                        >
                            <span>
                                <ArrowBackIcon className="color-white" />
                            </span>
                        </div>
                    </Link>
                </div>

                {productsSecondaryData.length !== 0 && kpiOoDataMappingData.length !== 0 && <CorrelationTab productsSecondaryData={productsSecondaryData} />}
                <div
                    style={{
                        position: "relative",
                        top: "67px",
                        height: "95px",
                    }}
                >
                    <MainNavigation
                        buttons={btnArr}
                        btnDisabledObj={btnDisabled}
                    />
                </div>
            </div>
        </>
    );
}

// Typechecking props for the OverallKpi
Correlation.propTypes = {
    headerTitle: PropTypes.string,
};

export default Correlation;
